// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom CSS */
.admin-auto-bdm .card {
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px; */
  overflow: hidden;
}

.admin-auto-bdm .bg-gradient {
  /* background: linear-gradient(135deg, #ff9800, #ffc107) !important; */
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;

  color: white;
  padding: 10px 20px;
  font-weight: 500;
  text-align: center;
  border-bottom: none;
}

.fs-7 {
  font-size: 0.55rem; /* Adjust as needed */
}

button.btn-preview {
  background-color: var(--button-custom-one);
  color: var(--whitefont-color);
  box-shadow: var(--button-custom-one-shadow);
}


button.btn-preview:hover {
  background-color: var(--button-custom-one-hover);
  color: var(--whitefont-color);
}

button.btn-Upload {
  background-color: var(--button-background);
  color: var(--whitefont-color);
  box-shadow: var(--button-box-shadow);
}


.admin-auto-bdm .card-body {
  max-height: 400px;
  overflow-y: auto;
}

.admin-auto-bdm .search-control {
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-auto-bdm .card-list-bdm {
  padding: 0;
  margin: 0;
  list-style: none;
}

.admin-auto-bdm .list-group-item {
  padding: 5px 15px;
  margin-bottom: 5px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.admin-auto-bdm .list-group-item:hover {
  background-color:var(--header-bg); ;
  color: #fff;
}

.admin-auto-bdm .active-column {
  background-color: transparent; /* Remove the background highlight */
  color:var(--header-bg); ; /* Set the text color to orange */
  border-color: transparent; /* Remove any border highlight */
  font-weight: bold;
}


/* .admin-auto-bdm .active-column:hover {
  background-color: #d95d00;
} */


/* Footer button custom styles */
/* .admin-auto-bdm .btn-custom {
  background-color: #26b7ec;
  border: none;
  width: 28px;
  height: 28px;
  font-size: 12px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
} */


.admin-auto-bdm .btn-custom {
  background-color: var(--bs-btn-bg, #26b7ec); /* Default to #26b7ec if --bs-btn-bg is not defined */
  border: var(--bs-btn-border-color, none); /* Default to no border if not defined */
  color: var(--bs-btn-color, black); /* Default text color */
  width: 28px;
  height: 28px;
  font-size: 12px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  

}
.admin-auto-bdm .btn-custom.mx-2:nth-of-type(2) {
  background-color: var(--header-bg); 
}

/* Disabled button state */
.admin-auto-bdm .btn-custom:disabled {
  background-color: #cccccc;
  color: #ffffff;
  cursor: not-allowed;
}

/* Scrollbar styling */
.admin-auto-bdm .card-body::-webkit-scrollbar {
  width: 6px;
}

.admin-auto-bdm .card-body::-webkit-scrollbar-thumb {
  background: var(--header-bg); ;
  border-radius: 10px;
}

/* Media queries for responsiveness */
@media (max-width: 768px) {
  .admin-auto-bdm .card {
    box-shadow: none;
    border-radius: 0;
  }
}


.admin-auto-bdm .row {
  margin-left: 80px;
}

/* .admin-auto-bdm .card {
  margin-left: 80px;
} */

.admin-auto-bdm .card-body {
  height: 330px;
  overflow-y: auto;
  margin-bottom: 5px;
}


.card-body + hr {
  position: static; /* Ensures the line below card-body is static */
}
.admin-auto-bdm .search-control {
  width: 70%;
  margin-right: 10px
}

hr {
  margin: 10px 0;
  border: 2px solid #ccC;
}

.admin-auto-bdm .form-control.search-control {
  width: 50%;
  margin-right: 10px;
}

.list-group.card-list-bdm {
  font-size: 12px;
}

.admin-auto-bdm .line-for-card {
  margin: 10px 0;  /* Corrected: removed quotes */
  border: 2px solid #ccc;  /* Corrected: removed quotes */
}


.custom-btn1 {
  --bs-btn-border-color: transparent; /* Override border color */
  --bs-btn-border-width: 0; /* Remove border width */
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  /* background-color: #4CAF50;  */
  color: rgb(0, 0, 0); /* Text color */
  font-size: 13px; /* Font size */
  font-weight: bold; /* Make text bold */
  border-radius: 5px; /* Rounded corners */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);  */
  /* Optional: Add shadow */
  cursor: pointer; /* Pointer cursor for the button */
  transition: background-color 0.3s ease, transform 0.3s ease; /* Smooth transition */
}

.custom-btn1:hover {
  /* background-color: #45a049;  */
  transform: translateY(-2px); /* Slight lift on hover */
}

.custom-btn1.active-column:hover {
  background-color: #ccc; /* Disabled button background */
  cursor: not-allowed; /* Change cursor for disabled button */
  opacity: 0.6; /* Disabled button opacity */
}

.Next-button-color{
  background-color: var(--Next-btn-bg-color);
  color: var(--Next-btn-txt-color);
}

.clear-btn-color
{
background-color: var(--clear-btn-bg-color);  
color: var(--clear-btn-txt-color);
}


.list-columns{
  font-size: var(--list-column-size);
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/AdminautoBDM.css"],"names":[],"mappings":"AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qGAAqG;EACrG,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,wFAAwF;;EAExF,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,2CAA2C;AAC7C;;;AAGA;EACE,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;AACtC;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,6BAA6B,EAAE,oCAAoC;EACnE,sBAAsB,IAAI,iCAAiC;EAC3D,yBAAyB,EAAE,gCAAgC;EAC3D,iBAAiB;AACnB;;;AAGA;;GAEG;;;AAGH,gCAAgC;AAChC;;;;;;;;;;GAUG;;;AAGH;EACE,2CAA2C,EAAE,qDAAqD;EAClG,wCAAwC,EAAE,wCAAwC;EAClF,iCAAiC,EAAE,uBAAuB;EAC1D,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;;;AAIzB;AACA;EACE,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB,EAAE,+CAA+C;AACnE;AACA;EACE,UAAU;EACV;AACF;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc,GAAG,8BAA8B;EAC/C,sBAAsB,GAAG,8BAA8B;AACzD;;;AAGA;EACE,kCAAkC,EAAE,0BAA0B;EAC9D,wBAAwB,EAAE,wBAAwB;EAClD,mEAAmE;EACnE,gCAAgC;EAChC,mBAAmB,EAAE,eAAe;EACpC,eAAe,EAAE,cAAc;EAC/B,iBAAiB,EAAE,mBAAmB;EACtC,kBAAkB,EAAE,oBAAoB;EACxC,+CAA+C;EAC/C,yBAAyB;EACzB,eAAe,EAAE,kCAAkC;EACnD,2DAA2D,EAAE,sBAAsB;AACrF;;AAEA;EACE,gCAAgC;EAChC,2BAA2B,EAAE,yBAAyB;AACxD;;AAEA;EACE,sBAAsB,EAAE,+BAA+B;EACvD,mBAAmB,EAAE,sCAAsC;EAC3D,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;AAEA,2CAA2C;AAC3C,iCAAiC;AACjC;;;AAGA;EACE,kCAAkC;AACpC","sourcesContent":["@import './background-colors.css';\r\n\r\n/* Custom CSS */\r\n.admin-auto-bdm .card {\r\n  border-radius: 10px;\r\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px; */\r\n  overflow: hidden;\r\n}\r\n\r\n.admin-auto-bdm .bg-gradient {\r\n  /* background: linear-gradient(135deg, #ff9800, #ffc107) !important; */\r\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\r\n\r\n  color: white;\r\n  padding: 10px 20px;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  border-bottom: none;\r\n}\r\n\r\n.fs-7 {\r\n  font-size: 0.55rem; /* Adjust as needed */\r\n}\r\n\r\nbutton.btn-preview {\r\n  background-color: var(--button-custom-one);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-custom-one-shadow);\r\n}\r\n\r\n\r\nbutton.btn-preview:hover {\r\n  background-color: var(--button-custom-one-hover);\r\n  color: var(--whitefont-color);\r\n}\r\n\r\nbutton.btn-Upload {\r\n  background-color: var(--button-background);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n\r\n.admin-auto-bdm .card-body {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.admin-auto-bdm .search-control {\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.admin-auto-bdm .card-list-bdm {\r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n\r\n.admin-auto-bdm .list-group-item {\r\n  padding: 5px 15px;\r\n  margin-bottom: 5px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.admin-auto-bdm .list-group-item:hover {\r\n  background-color:var(--header-bg); ;\r\n  color: #fff;\r\n}\r\n\r\n.admin-auto-bdm .active-column {\r\n  background-color: transparent; /* Remove the background highlight */\r\n  color:var(--header-bg); ; /* Set the text color to orange */\r\n  border-color: transparent; /* Remove any border highlight */\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n/* .admin-auto-bdm .active-column:hover {\r\n  background-color: #d95d00;\r\n} */\r\n\r\n\r\n/* Footer button custom styles */\r\n/* .admin-auto-bdm .btn-custom {\r\n  background-color: #26b7ec;\r\n  border: none;\r\n  width: 28px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n} */\r\n\r\n\r\n.admin-auto-bdm .btn-custom {\r\n  background-color: var(--bs-btn-bg, #26b7ec); /* Default to #26b7ec if --bs-btn-bg is not defined */\r\n  border: var(--bs-btn-border-color, none); /* Default to no border if not defined */\r\n  color: var(--bs-btn-color, black); /* Default text color */\r\n  width: 28px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  \r\n\r\n}\r\n.admin-auto-bdm .btn-custom.mx-2:nth-of-type(2) {\r\n  background-color: var(--header-bg); \r\n}\r\n\r\n/* Disabled button state */\r\n.admin-auto-bdm .btn-custom:disabled {\r\n  background-color: #cccccc;\r\n  color: #ffffff;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.admin-auto-bdm .card-body::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.admin-auto-bdm .card-body::-webkit-scrollbar-thumb {\r\n  background: var(--header-bg); ;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Media queries for responsiveness */\r\n@media (max-width: 768px) {\r\n  .admin-auto-bdm .card {\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n  }\r\n}\r\n\r\n\r\n.admin-auto-bdm .row {\r\n  margin-left: 80px;\r\n}\r\n\r\n/* .admin-auto-bdm .card {\r\n  margin-left: 80px;\r\n} */\r\n\r\n.admin-auto-bdm .card-body {\r\n  height: 330px;\r\n  overflow-y: auto;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n\r\n.card-body + hr {\r\n  position: static; /* Ensures the line below card-body is static */\r\n}\r\n.admin-auto-bdm .search-control {\r\n  width: 70%;\r\n  margin-right: 10px\r\n}\r\n\r\nhr {\r\n  margin: 10px 0;\r\n  border: 2px solid #ccC;\r\n}\r\n\r\n.admin-auto-bdm .form-control.search-control {\r\n  width: 50%;\r\n  margin-right: 10px;\r\n}\r\n\r\n.list-group.card-list-bdm {\r\n  font-size: 12px;\r\n}\r\n\r\n.admin-auto-bdm .line-for-card {\r\n  margin: 10px 0;  /* Corrected: removed quotes */\r\n  border: 2px solid #ccc;  /* Corrected: removed quotes */\r\n}\r\n\r\n\r\n.custom-btn1 {\r\n  --bs-btn-border-color: transparent; /* Override border color */\r\n  --bs-btn-border-width: 0; /* Remove border width */\r\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\r\n  /* background-color: #4CAF50;  */\r\n  color: rgb(0, 0, 0); /* Text color */\r\n  font-size: 13px; /* Font size */\r\n  font-weight: bold; /* Make text bold */\r\n  border-radius: 5px; /* Rounded corners */\r\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);  */\r\n  /* Optional: Add shadow */\r\n  cursor: pointer; /* Pointer cursor for the button */\r\n  transition: background-color 0.3s ease, transform 0.3s ease; /* Smooth transition */\r\n}\r\n\r\n.custom-btn1:hover {\r\n  /* background-color: #45a049;  */\r\n  transform: translateY(-2px); /* Slight lift on hover */\r\n}\r\n\r\n.custom-btn1.active-column:hover {\r\n  background-color: #ccc; /* Disabled button background */\r\n  cursor: not-allowed; /* Change cursor for disabled button */\r\n  opacity: 0.6; /* Disabled button opacity */\r\n}\r\n\r\n.Next-button-color{\r\n  background-color: var(--Next-btn-bg-color);\r\n  color: var(--Next-btn-txt-color);\r\n}\r\n\r\n.clear-btn-color\r\n{\r\nbackground-color: var(--clear-btn-bg-color);  \r\ncolor: var(--clear-btn-txt-color);\r\n}\r\n\r\n\r\n.list-columns{\r\n  font-size: var(--list-column-size);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
